module.exports = __webpack_public_path__ + "img/guangxi.b273f2b4.png";